"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgItalic = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M13 20H7c-.666 0-1-.333-1-.999 0-.665.334-.999 1-1.001h2l4-12h-2c-.662 0-.994-.334-.994-1 0-.668.332-1 .995-1h6.004c.663.04.995.374.995 1 0 .625-.332.958-.995 1h-2.003L11 18h2c.668 0 1.002.335 1.002 1.001 0 .667-.334 1-1.002.998V20z' }))); };
exports.default = SvgItalic;
//# sourceMappingURL=Italic.js.map